import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { withRouter } from "react-router";
import { Table, TableBody, TableCell, TableHead, TableSortLabel, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Divider, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Chip } from '@material-ui/core';
import { AssetInfo } from '../components'
import { TechSpecsNav } from "../../elements";
import { DeletePopUp, EmptyCollection, PageLoader, Pagination, STableLoader } from "../../shared_elements";
import { globalDeleteService, globalGetService, globalPostService, globalPutService } from "../../../globalServices";
import { checkApiStatus, checkPermission } from "../../utils_v2";
import { DropzoneArea } from "material-ui-dropzone";
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { assetValueKey } from "../../fleet";
import AttachmentsRow from "../../../shared/components/AttachmentsRow";
import PreviewDocsModal from "../../../shared/components/PreviewDocsModal";
import CustomChip from "../../../shared/components/CustomChip";
const ModuleHD = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Item</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Attachments</TableCell>
                <TableCell align="right">Action(s)</TableCell>
            </TableRow>
        </TableHead>
    )
}
const ModuleListing = ({ item, onEdit, onDelete }) => {
    return (
        <TableRow>
            <TableCell>{item?.item || '--'}</TableCell>
            <TableCell>{item?.description || '--'}</TableCell>
            <TableCell>{item?.attachments?.length > 0 ? <AttachmentsRow attachmentsData={item?.attachments} /> : "--"}</TableCell>
            <TableCell align="right">{
                <ul className="list-inline" style={{ width: '80px', float: 'right' }}>
                    {checkPermission('technical_specs', 'attachments_sub_module', 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onEdit}>
                        <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                    </li>:null}
                    {checkPermission('technical_specs', 'attachments_sub_module', 'D') ?
                    <li className="list-inline-item hover-inline" onClick={onDelete}>
                        <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                    </li>:null}
                </ul>}</TableCell>
        </TableRow>
    )
}
const AddSubModule = ({ addEditSubModule, toggleModalFn, getResponseBack, params, setPreviewDocs, getListApi }) => {
    const [subModule, setSubModule] = useState(addEditSubModule?.data?.id ? addEditSubModule?.data : {})
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({})
    const [deleteAttachment, setdeleteAttachment] = useState({ modal: false, data: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const addAttachmentsFn = (id, data) => {
        const formdata = new FormData()
        data.map(item => {
            formdata.append('files', item)
        })
        formdata.append('asset_type', assetValueKey[params?.type])
        formdata.append('asset_slug', params.aircraft_slug)
        formdata.append('model_type', 2)
        formdata.append('object_id', id)
        globalPostService(`/console/attachments/`, formdata)
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleModalFn(); getResponseBack();
                    setLoading(false)
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    setLoading(false)
                    toggleModalFn(); getResponseBack();
                }
            })
    }
    const onAddEditSubModule = () => {
        let totalFiles = subModule.attachments?.length + subModule?.files?.length
        if (totalFiles > 10) {
            enqueueSnackbar("Maximum allowed number of files exceeded. Only 10 allowed.", { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
        } else {
            let validateInput = {}
            validateInput = {
                item: subModule?.item?.trim()?.length ? '' : 'Please enter Item',
                files: subModule?.attachments?.length || subModule?.files?.length ? '' : 'Please upload the attachments.'
            }
            let payload = {
                description: subModule.description || '',
                item: subModule.item
            }
            if (Object.keys(validateInput).every(k => validateInput[k] === '')) {
                setLoading(true)
                if (subModule.id) {
                    globalPutService(`console/v2/asset/${params.type}/${params.aircraft_slug}/sub-module/${subModule.id}/`, payload)
                        .then(response => {
                            if (checkApiStatus(response)) {
                                if (subModule?.files?.length) {
                                    addAttachmentsFn(subModule.id, subModule?.files)
                                } else {
                                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                    getResponseBack();
                                }
                            }
                        })
                } else {
                    globalPostService(`console/v2/asset/${params.type}/${params.aircraft_slug}/sub-module/`, payload)
                        .then(response => {
                            if (checkApiStatus(response)) {
                                if (subModule?.files?.length) {
                                    addAttachmentsFn(response.data.data.id, subModule?.files)
                                } else {
                                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                    getResponseBack();
                                }
                            }
                        })
                }
            }
            else{
                setError(validateInput)
            }
            }
        }
        const deleteModuleAttachment = (item) => {
            setLoading(true)
            globalDeleteService(`console/attachments/${item.uuid}/`)
                .then((response) => {
                    if (checkApiStatus(response)) {
                        const updatedAttachments = subModule.attachments.filter(att => att.uuid !== item.uuid);
                        setSubModule({ ...subModule, attachments: updatedAttachments });
                        setdeleteAttachment({ modal: false, data: null })
                        getListApi();
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                    setLoading(false)
                })
        };
        const onDeleteChip = (file, index) => {
            setSubModule({ ...subModule, 'files': subModule?.files.filter(item => item?.name !== file?.name) });
        }
        const onDropFiles = (files) => {
            setSubModule({ ...subModule, 'files': files });
            setError({ ...error, 'files': '' })
        }
        return (
            <>
                <Dialog
                    open={addEditSubModule.modal}
                    onClose={toggleModalFn}
                    className='console-management-modal'
                    maxWidth="md"
                >
                    <DialogTitle id="scroll-dialog-title">
                        {subModule?.id ? 'Edit ' : 'Add '} Attachments
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <TextField
                                    required
                                    id='item'
                                    label='Item'
                                    value={subModule?.item || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 250 }}
                                    onChange={(e) => setSubModule({ ...subModule, 'item': e.target.value })}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.item}
                                    helperText={error?.item || ''}
                                    onFocus={() => setError({ ...error, 'item': '' })}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    id='description'
                                    label='Description'
                                    value={subModule?.description || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 250 }}
                                    onChange={(e) => setSubModule({ ...subModule, 'description': e.target.value })}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                   
                                />
                            </Grid>
                            <Grid item md={12}>
                                <div>
                                    <DropzoneArea
                                        acceptedFiles={['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf', '.xls', '.xlsx']}
                                        filesLimit={10}
                                        maxFileSize={104857600}
                                        showPreviewsInDropzone={false}
                                        useChipsForPreview={true}
                                        showPreviews={true}
                                        onDelete={(item, index) => onDeleteChip(item, index)}
                                        dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                        dropzoneClass="drag-drop-cnt"
                                        showAlerts={['info', 'error']}
                                        alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                        clearOnUnmount={true}
                                        onDrop={(files) => { onDropFiles(files) }}
                                    />
                                </div>
                                <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension ('.pdf, images/, .xls, .xlsx').</span> <br />
                                {error?.files ? <p className="error-msg">{error?.files}</p> : null}
                                {subModule?.attachments?.length ? subModule?.attachments && subModule?.attachments.map((file, index) => (
                                    <CustomChip
                                        style={{ marginRight: '4px', marginTop: '7px' }}
                                        title={file.name}
                                        index={index}
                                        label={file.name.substring(0, 14) + '...'}
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPreviewDocs(file); }}
                                        onDelete={() => setdeleteAttachment({ modal: true, data: file })}
                                    />
                                )) : null}

                            </Grid>

                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                        <Button disabled={isLoading} onClick={onAddEditSubModule} color='primary' size='small' variant='contained'>
                            {isLoading ? <CircularProgress size={24} /> : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog>
                {deleteAttachment.modal ?
                    <DeletePopUp
                        modal={deleteAttachment.modal}
                        title={`Delete Attachment (${deleteAttachment?.data?.name})`}
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setdeleteAttachment({ modal: false, data: null })}
                        deleteRecordFn={() => deleteModuleAttachment(deleteAttachment?.data)}
                        isLoading={isLoading}
                    /> : null
                }
            </>
        )
    }
    function AttachmentSubModule({ params }) {
        const { enqueueSnackbar, closeSnackbar } = useSnackbar();
        const [isLoading, setLoading] = useState(false);
        const [skeletonLoader, setSkeletonLoader] = useState(false);
        const [moduleList, setModuleList] = useState({ list: [], pagination: null });
        const [addEditSubModule, setAddEditSubModule] = useState({ modal: false, data: null });
        const [deleteAttachment, setDeleteAttachment] = useState({ modal: false, data: null });
        const [assetInfoData, setAssetInfoData] = useState();
        const [assetSkeletonLoader, setAssetSkeletonLoader] = useState(false);
        const [previewDocs, setPreviewDocs] = useState("")

        useEffect(() => {
            getAssetInfo('assetSkeletonLoader');
            getModuleList({}, 'skeletonLoader');
        }, []);
        const getAssetInfo = (loaderType) => {
            loaderType === 'assetSkeletonLoader' ? setAssetSkeletonLoader(true) : setLoading(true);
            globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/asset_details/`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setAssetInfoData(response.data.data);
                    }
                    loaderType === 'assetSkeletonLoader' ? setAssetSkeletonLoader(false) : setLoading(false);
                })
        }
        const getModuleList = (query, loaderType) => {
            loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
            globalGetService(`console/v2/asset/${params.type}/${params.aircraft_slug}/sub-module/`, query)
                .then(response => {
                    loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
                    if (checkApiStatus(response)) {
                        setModuleList(response.data.data)
                    }
                })
        }

        const onDeleteAttachment = () => {
            setLoading(true);
            globalDeleteService(`console/v2/asset/${params.type}/${params.aircraft_slug}/sub-module/${deleteAttachment.data.id}/`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        setDeleteAttachment({ modal: false, data: null })
                        getModuleList({}, 'pageLoader');
                    }
                    setLoading(false);
                })
        }

        return (
            <section className="asset-tech-specs">
                <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={() => getAssetInfo()} />
                <Paper className="tech-specs-card" style={{ minHeight: `${window.innerHeight - 162}px` }} >
                    <TechSpecsNav />
                    <div className="tech-specs-content">
                        {isLoading ? <PageLoader /> : null}
                        {skeletonLoader ? <STableLoader count={8} /> :
                            <div style={{ padding: '10px' }}>
                                <Paper >
                                    <ul className="list-inline" style={{ textAlign:"right", marginBottom: '5px' }}>
                                    {checkPermission('technical_specs', 'attachments_sub_module', 'C') ?
                                        <li>
                                            <Button onClick={() => setAddEditSubModule({ modal: true, data: {} })} color='primary' size='small' variant='contained'>Add Attachments</Button>
                                        </li>:null}
                                    </ul>
                                    <Paper style={{ height: !moduleList?.list?.length? `150px`: `${window.innerHeight - 262}px`, overflow: 'scroll' }}>
                                    <Table className='mui-table-format' stickyHeader>
                                        <ModuleHD />
                                        <TableBody>
                                            {moduleList?.list?.length ?
                                                moduleList?.list?.map(item =>
                                                    <ModuleListing
                                                        onEdit={() => setAddEditSubModule({ data: item, modal: true })}
                                                        onDelete={() => setDeleteAttachment({ data: item, modal: true })}
                                                        item={item}
                                                    />) : null
                                            }
                                        </TableBody>
                                    </Table>
                                    {!moduleList?.list?.length && !isLoading ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                    </Paper>
                                </Paper>
                                {moduleList?.pagination ?
                                    <Paper>
                                        <Pagination
                                            pagination={moduleList.pagination}
                                            onChangePage={(event, newPage) => getModuleList({ page: newPage + 1, per_page: moduleList.pagination.per_page }, 'pageLoader')}
                                            onChangeRowsPerPage={(event) => getModuleList({ page: 1, per_page: event.target.value }, 'pageLoader')}
                                        />
                                    </Paper>
                                    : null}
                            </div>}
                    </div>
                    {addEditSubModule?.modal ?
                        <AddSubModule
                            params={params}
                            addEditSubModule={addEditSubModule}
                            toggleModalFn={() => setAddEditSubModule({})}
                            getResponseBack={() => { setAddEditSubModule({}); getModuleList() }}
                            setPreviewDocs={setPreviewDocs}
                            getListApi={getModuleList}
                        /> : null
                    }
                    {deleteAttachment?.modal ?
                        <DeletePopUp
                            modal={deleteAttachment.modal}
                            title='Delete Attachment'
                            content={`Are you sure, you want to Delete?`}
                            toggleModalFn={() => setDeleteAttachment({ modal: false, data: null })}
                            deleteRecordFn={onDeleteAttachment}
                        /> : null
                    }
                    {previewDocs ? (
                        <PreviewDocsModal previewDocs={previewDocs} toggleModalFn={() => setPreviewDocs("")} />
                    ) : null}
                </Paper>
            </section>

        )
    }
    export default withRouter(AttachmentSubModule)
